import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { TableCell, TableRow, Checkbox } from '@mui/material';
import { onCheckBoxChange } from 'utils/propertyChangeAdapters';

import { RightsContext } from 'providers/RightsContext';
export const OfferInsuranceProductRow = ({ product, companies, onProductPropertyChange, t, idx }) => {
  const company = companies.filter(item => item.insuranceCompanyId === product.insuranceCompanyId)[0];
  const { readOnlyFull } = useContext(RightsContext);

  return (
    <TableRow>
      <TableCell>
        <Checkbox
          id={'offerInsuranceCard_product_' + idx + '_selected'}
          checked={product.selected}
          onChange={onCheckBoxChange(onProductPropertyChange('selected'))}
          disabled={readOnlyFull}
        />
      </TableCell>
      <TableCell>{company?.name}</TableCell>
      <TableCell>{product.name}</TableCell>
      <TableCell align={'right'}>{t('NUMBER', { number: product.value })}</TableCell>
      <TableCell align={'right'}>{t('NUMBER', { number: product.paymentValue })}</TableCell>
    </TableRow>
  );
};
OfferInsuranceProductRow.propTypes = {
  product: PropTypes.object.isRequired,
  companies: PropTypes.array.isRequired,
  onProductPropertyChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  idx: PropTypes.number.isRequired
};

export default withTranslation()(OfferInsuranceProductRow);
